import { EloCategory } from '../models/elo.model';
import { formatElo } from './format-elo';
import { getCategoryByElo } from './get-category-by-elo';

/** Shared visual style for Elo rating chips on team/player lists. */
export const ELO_RATING_BADGE_CLASSNAME =
  'shrink-0 border-transparent bg-blue-100 text-blue-800 shadow hover:bg-blue-200/80 hover:text-blue-900';

/**
 * Single-line badge text: `Category (Elo 1234)` when a category band matches; otherwise `Elo 1234`.
 */
export function formatEloBadgeLabel(
  elo: number,
  eloCategories: EloCategory[],
): string {
  const category = getCategoryByElo(eloCategories, elo);
  const n = formatElo(elo);
  if (category) {
    return `${category} (Elo ${n})`;
  }
  return `Elo ${n}`;
}
